import React, {Component} from 'react';
import withUserActivityTracker from '../../decorators/UserActivityTracker';
import KioskTimeoutKicker from '../KioskTimeoutKicker';
import KioskWarningWrapper from "../KioskWarningWrapper/KioskWarningWrapper";

class KioskComponentsContainer extends Component {
    render() {
        return (
            <div>
                <KioskWarningWrapper/>
                <KioskTimeoutKicker/>
                {this.props.children}
            </div>
        );
    }
}

export default withUserActivityTracker(KioskComponentsContainer);


// WEBPACK FOOTER //
// ./src/components/KioskComponentsContainer/KioskComponentsContainer.jsx